import type { Customer, StoreState } from "@store/types";
import {
    applyBaseCustomerFields,
    applyVersionLogic,
    applyAdditionalFields,
} from "./set-profile-helpers";

export const updateProfile = (customer: Customer) => (state: StoreState) => {
    const me = state.data.me;

    if (!me.customer) {
        me.customer = {} as Customer;
    }

    const customerState = me.customer;

    applyBaseCustomerFields(customerState, customer);
    applyVersionLogic(customerState, customer);
    applyAdditionalFields(customerState, customer);
};
